// contexts/ChameleonContext.ts
import { createContext, useContext } from 'react';
import type { ChameleonEntityType, ChameleonSession } from '@/api/core/chameleonState';

// The shape is owned by api/core/chameleonState — sessionStorage is the single
// source of truth for the impersonated identity, and this context is a React-side
// view onto it. Re-exported here so existing consumers keep their import path.
export type { ChameleonEntityType };
export type ChameleonState = ChameleonSession;

export interface ChameleonContextValue {
    chameleon: ChameleonState;
    activate: (entityType: ChameleonEntityType, entityId: number, entityName: string) => void;
    deactivate: () => void;
}

export const ChameleonContext = createContext<ChameleonContextValue | null>(null);

export const useChameleon = (): ChameleonContextValue => {
    const ctx = useContext(ChameleonContext);
    if (!ctx) throw new Error('useChameleon must be used inside ChameleonProvider');
    return ctx;
};
